export default __webpack_public_path__ + "static/logo_mongodb-28070dac02736bc56b3c9ece60da4b53.png";